export default __webpack_public_path__ + "static/blob16-cb544dea080996b0ed8c09c18bca13f1.svg";